<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";

// Custom components
import PageHeader from "@/components/page-header";
import avatarAddEditDrawer from "@/components/superAdmin/videoBot/avatar/avatarAddEditDrawer.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "List Of Avatar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "List Of Avatar",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Avatar",
          active: true,
        },
      ],
      addEditAvatar: false,
      openNewRequestForm: false,
      isEdit: false,
      isEditable: true,
      tableData: [],
      hotels: [],
      updateValue: "",
      isDataLoading: false,
      is_btn_loading: false,
      hotelId: "",
      hotelName: "",
      selected: "all",
    };
  },
  components: {
    PageHeader,
    Drawer,
    avatarAddEditDrawer,
  },
  computed: {
    ...authComputed,
    avatarProps() {
      return {
        isEdit: this.isEdit,
        updateValue: this.updateValue,
        isEditable: this.isEditable,
        hotelId: this.hotelId,
        hotelName: this.hotelName,
      };
    },
  },
  mounted() {
    this.getListOfAvatar();
  },

  methods: {
    // Get list of all avatar
    async getListOfAvatar() {
      this.isDataLoading = true;
      await UserService.getBotAvatarList().then((response) => {
        this.isDataLoading = false;
        this.tableData = response.avatarList;
      });
    },

    addEditAvatarDrawer() {
      if (this.addEditAvatar === true) {
        this.isEdit = false;
        this.updateValue = "";
      }
      this.addEditAvatar = !this.addEditAvatar;
    },

    avatarAddedUpdated(data, isEdit) {
      if (isEdit) {
        this.tableData = this.tableData.map((item) => {
          if (item.avatarId === data.avatarId) {
            item = data;
          }
          return item;
        });
      } else {
        this.tableData.push(data);
      }
      this.addEditAvatarDrawer();
    },

    saveAndAddNewAvatar(data) {
      this.tableData.push(data);
      this.addEditAvatarDrawer();
    },

    editAvatar(data, type) {
      this.isEdit = true;
      this.updateValue = data;
      this.addEditAvatarDrawer();
    },
    deleteAvatar(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteBotAvatar(id)
            .then((response) => {
              this.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "danger");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    intentAvatar(id) {
      this.$router.push({
        path: "/avatar-intent",
        query: {
          avatar_id: id,
        },
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="hotelName ? '' + hotelName + ' for ' + title : 'All ' + title"
      :items="items"
      :action="addEditAvatarDrawer"
      text="Add New"
      :isButton="true"
    />

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div
            class="col-md-2"
            v-for="(data, index) in tableData"
            :key="data.id"
          >
            <div class="card">
              <div class="card-body text-center">
                <b-dropdown
                  class="float-end"
                  toggle-class="text-muted p-0"
                  menu-class="dropdown-menu-end"
                  right
                  variant="white"
                  style="margin-top: -19px; margin-right: -15px"
                >
                  <template v-slot:button-content>
                    <i class="mdi mdi-dots-vertical fs-2"></i>
                  </template>
                  <b-dropdown-item @click="intentAvatar(data.id)"
                    >Intent List</b-dropdown-item
                  >
                  <b-dropdown-item @click="editAvatar(data, false)"
                    >Edit</b-dropdown-item
                  >
                  <b-dropdown-item @click="deleteAvatar(data.id, index)"
                    >Delete</b-dropdown-item
                  >
                </b-dropdown>
                <div>
                  <img
                    :src="
                      'https://vod-lex-files.s3.amazonaws.com/' + data.photo
                    "
                    alt=""
                    class="avatar-lg rounded-circle img-thumbnail object-fit"
                  />
                  <div class="text-muted">
                    <h5>{{ data.name }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer -->
    <Drawer
      @close="addEditAvatarDrawer"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="addEditAvatar">
        <avatarAddEditDrawer
          :currentProps="avatarProps"
          @submitted="avatarAddedUpdated"
          @cancelSubmit="addEditAvatarDrawer"
          @saveAndAddNew="saveAndAddNewAvatar"
        ></avatarAddEditDrawer>
      </div>
    </Drawer>
  </div>
</template>
